import { Table } from 'uikit';

import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import type { ITableLikeTreeFilterItem } from '../context';
import { useTableTreeLeftFilterColumns } from '../hooks/useTableTreeLeftFilterColumns';

import Style from './LeftFilter.module.css';

interface ILeftFilter {
    items?: ITableLikeTreeFilterItem[];
    checkedIds: number[];
    onCheckChange: (checkedIds: number[], item?: ITableLikeTreeFilterItem, isChecked?: boolean) => any;
    disabled?: boolean;
    title?: string;
    onRowSelected?: (itemId: number) => void;
    selectedId?: number;
    isMenuColumnVisible?: boolean;
    mainCheckedIds: number[];
    showCheckedMainItems?: boolean;
    checkedCountCache?: Record<string, number>;
}

export const LeftFilter: React.FC<ILeftFilter> = (props) => {
    const {
        items = [],
        checkedIds,
        onCheckChange,
        disabled,
        title,
        onRowSelected,
        selectedId,
        isMenuColumnVisible = true,
        mainCheckedIds,
        showCheckedMainItems,
        checkedCountCache,
    } = props;
    const [selectedRowId, setSelectedRowId] = useState(selectedId);

    useEffect(() => {
        setSelectedRowId(selectedId);
    }, [selectedId]);

    const columns = useTableTreeLeftFilterColumns({
        items,
        checkedIds,
        onCheckChange,
        disabled,
        title,
        isMenuColumnVisible,
        selectedId,
        mainCheckedIds,
        showCheckedMainItems,
        checkedCountCache,
    });

    const onRowClick = useCallback(
        ({ id }) => {
            setSelectedRowId(id);
            onRowSelected?.(id);
        },
        [onRowSelected],
    );

    const getAdditionalClassName = useCallback(
        ({ row }) => (String(selectedRowId) === String(row.id) ? 'selected' : ''),
        [selectedRowId],
    );

    return (
        <Table
            columns={columns as any}
            rows={items as any}
            size="s"
            stickyHeader
            borderBetweenColumns
            verticalAlign="center"
            onRowClick={onRowClick}
            getAdditionalClassName={getAdditionalClassName}
            className={Style.leftFilter}
        />
    );
};

LeftFilter.displayName = 'LeftFilter';
